module.exports = __webpack_public_path__ + "img/062-raindrop.7e94f5a9.svg";